import { render, staticRenderFns } from "./more-calculators.vue?vue&type=template&id=96b4f07e&scoped=true&"
import script from "./more-calculators.vue?vue&type=script&lang=js&"
export * from "./more-calculators.vue?vue&type=script&lang=js&"
import style0 from "./more-calculators.vue?vue&type=style&index=0&id=96b4f07e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b4f07e",
  null
  
)

export default component.exports